import React from "react";
import { FIXED_CONTAINER } from "./assets";
import styles from './FixedContainerIPA.module.scss';
import { downloadApk, DownloadSimulator ,GetIPAUrl} from "./Helper";
export default function FixedContainer() {
    const onClickDownloadSimulator = () => {
        DownloadSimulator();
    }
    const onClickDownload = () => {
        downloadApk();
    }
    const onClickJiaocheng=()=>{
      
        let url = `https://${process.env.REACT_APP_SLUG}-ios.18-jgg.com/testflight3.html?showname=${process.env.REACT_APP_TITLE}&iconurl=${process.env.REACT_APP_SLUG}`
        window.open(url)
    }
    const onClickI4=()=>{
        window.open('https://i4.cn')
    }
    const onClickIPA=()=>{
        GetIPAUrl(process.env.REACT_APP_SLUG)
    }
    return (
        <div className={styles["container"]}>
            <img src={FIXED_CONTAINER.DOWNLOAD_BACKGROUND.default} alt="Background" />
            <div className={styles["main-container"]}>
                <div className={styles["group1"]}>
                    <img src={FIXED_CONTAINER.BUTTON_1.default} className={styles["button-1"]} alt="button_1" onClick={onClickJiaocheng} />
                    <img src={FIXED_CONTAINER.BUTTON_2.default} className={styles["button-2"]} alt="button_2" onClick={onClickI4} />
                </div>
                <div className={styles["group2"]}>
                    <img src={FIXED_CONTAINER.BUTTON_3.default} className={styles["button-3"]} alt="button_3" onClick={onClickIPA} />

                </div>
                <div className={styles["group3"]}>
                    <img src={FIXED_CONTAINER.BUTTON_4.default} className={styles["button-4"]} alt="button_4" onClick={onClickDownloadSimulator} />
                    <img src={FIXED_CONTAINER.BUTTON_5.default} className={styles["button-5"]} alt="button_5" onClick={onClickDownload} />
                </div>
                {/* <div className={styles["icon-container"]}>
                    <img src={FIXED_CONTAINER.ICON_1.default} alt="Icon" />
                </div>
                <div className={styles["button-container"]}>
                    <img src={FIXED_CONTAINER.BUTTON_1.default}
                        alt="Button" onClick={ onClickDownloadSimulator}
                    />
                </div>
                <div className={styles["icon-container"]}>
                    <img src={FIXED_CONTAINER.ICON_2.default} alt="Icon" />
                </div>
                <div className={styles["button-container"]}>
                    <img src={FIXED_CONTAINER.BUTTON_2.default}
                        alt="Button"
                        onClick={onClickDownload}
                    />
                </div> */}
            </div>
        </div>
    )
}

